export default __webpack_public_path__ + "static/media/nocar.36e1e459.png";